import { useEffect } from 'react';
import './context/index.js';
import logger from './utils/logger.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import { s as serverErrors } from './serverErrors-_VHsjhgw.js';
import './payment-YC9H491Y.js';
import './index-mh98rJ1p.js';
import 'next/router';
import useShowError from './hooks/useShowError.js';
import 'notistack';
import { useTranslation } from 'next-i18next';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import './utils/currency.js';
import 'next/server';
import './index-Oip0gjfj.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';

// Show server error in snackbar
const ServerError = ({ error }) => {
    const showError = useShowError();
    const { t } = useTranslation('', { keyPrefix: '' });
    const formattedError = () => {
        const errorObj = serverErrors.find(knownError => knownError.serverError === error);
        if (errorObj && errorObj.userFriendlyError) {
            logger(error, { type: 'error', preText: 'Server error:' });
            return t(errorObj.userFriendlyError);
        }
        logger(error, { type: 'error', preText: 'Server error:' });
        return null;
    };
    useEffect(() => {
        if (error && formattedError) {
            showError(formattedError());
        }
    }, [error]);
    return null;
};
var ServerError$1 = withProviders(ServerError, { translation: true });

export { ServerError$1 as S };
//# sourceMappingURL=ServerError-Mwb2HL69.js.map
